import types from '../types'
import axios from 'axios'
import { getApiServer } from '../../utils/helpers'

const server = getApiServer()

export const generateCarePlan = (encounterId, patient, healthSystemId) => async (dispatch) => {
  dispatch({ type: types.SET_CAREPLAN_REQUESTED })
  try {
    const careplan = await axios.post(server + '/api/ccp', { encounterId, patientId: patient.patientId, healthSystemId })
    dispatch({ type: types.SET_CAREPLAN_FULFILLED, payload: careplan.data })
  } catch (error) {
    console.log(error)
    dispatch({ type: types.SET_CAREPLAN_REJECTED, payload: error })
  }
}

export const getCarePlan = (encounterId) => async (dispatch) => {
  dispatch({ type: types.SET_CAREPLAN_REQUESTED })
  try {
    const opportunities = await axios.get(server + '/api/opportunity')
    const patientOpportunities = await axios.get(server + '/api/opportunities', { params: { encounterId } })

    const rules = await axios.get(server + '/api/rules', { params: { kind: 'ccp' } })

    const patientRecommendations = await axios.get(server + '/api/recommendations', { params: { encounterId } })
    const patientActions = await axios.get(server + '/api/actions', { params: { encounterId } })
    dispatch({ type: types.GET_CAREPLAN_FULFILLED, payload: { opportunities: opportunities.data, patientOpportunities: patientOpportunities.data, rules: rules.data, patientActions: patientActions.data, recommendations: patientRecommendations.data } })
  } catch (error) {
    dispatch({ type: types.SET_CAREPLAN_REJECTED, payload: error })
  }
}

export const updateCareplanOpportunity = (target) => (dispatch) => {
  dispatch({ type: types.UPDATE_CAREPLAN_OPPORTUNITY, payload: target })
}

export const updateCareplanRule = (target) => (dispatch) => {
  dispatch({ type: types.UPDATE_CAREPLAN_RULE, payload: target })
}

export const updateCareplanAction = (target, ruleId) => (dispatch) => {
  dispatch({ type: types.UPDATE_CAREPLAN_ACTION, payload: { target, ruleId } })
}

export const updateCareplanSubAction = (target, ruleId, actionId) => (dispatch) => {
  dispatch({ type: types.UPDATE_CAREPLAN_SUB_ACTION, payload: { target, ruleId, actionId } })
}

export const saveCarePlan = (encounter, opportunities, rules, actions, subActions, orders) => async (dispatch) => {
  dispatch({ type: types.SAVE_CAREPLAN_REQUESTED })
  // const { patient: { encounter }, ccp: { opportunities, rules, actions, subActions }, wrapup: { orders } } = getState()
  try {
    await axios.post(server + '/api/opportunities', { encounter, opportunities })
    await axios.post(server + '/api/recommendations', { encounter, rules })
    await axios.post(server + '/api/actions', { encounter, actions, rules, subActions, orders })
    dispatch({ type: types.SAVE_CAREPLAN_FULFILLED })
  } catch (error) {
    dispatch({ type: types.SAVE_CAREPLAN_REJECTED, payload: error })
  }
}

export const clearCarePlan = () => (dispatch) => {
  dispatch({ type: types.CLEAR_CAREPLAN })
}

export const updateWrapUpAction = (target, action) => (dispatch) => {
  dispatch({ type: types.UPDATE_WRAP_UP_ACTION, payload: { target, action } })
}

export const generateNote = (orders, scheduling, rx, patientEd, orderReferrals) => async (dispatch, getState) => {
  const { patient: { encounter, patient }, assessment: { s2k, pendS2k, lldas, pga, damage, flare, damageIsNull, flareIsNull }, ccp: { rules, actions, subActions } } = getState()
  dispatch({ type: types.CREATE_ASSEMBLED_NOTE_REQUESTED })
  try {
    const note = await axios.post(server + '/api/note', {
      encounterId: encounter.encounterId,
      patientId: patient.patientId,
      s2k,
      orders,
      rx,
      schedule: scheduling,
      patientEd,
      referrals: orderReferrals,
      pendS2k,
      lldas,
      pga,
      damage,
      flare,
      damageIsNull,
      flareIsNull,
      rules,
      actions,
      subActions
    })
    dispatch({ type: types.CREATE_ASSEMBLED_NOTE_FULFILLED, payload: note.data })
  } catch (error) {
    dispatch({ type: types.CREATE_ASSEMBLED_NOTE_REJECTED, payload: error })
  }
}

export const updateAssembledNote = (value) => (dispatch) => {
  dispatch({ type: types.UPDATE_ASSEMBLED_NOTE, payload: value })
}

export const updateNote = (key, id, value) => (dispatch) => {
  dispatch({ type: types.UPDATE_WRAP_UP_NOTE, payload: { key, id, value } })
}

export const setEditNote = (editing) => (dispatch) => {
  dispatch({ type: types.SET_EDITING_NOTE, payload: editing })
}
